import React from 'react';

const EditActionButton = (props) => {
  function handleClick(event) {
    event.preventDefault();
    props.onEdit();
  }

  return (
    <button
      className="button secondary small"
      onClick={event => handleClick(event)}
    >
      <i className="fa fa-pencil" />
      <span>Edit {props.label}</span>
    </button>
  );
};

export default EditActionButton;
